import { ModalHeader } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import { confirmAlert } from 'react-confirm-alert';
import { notifyError, notifySuccess } from '../../../services/notify';
import React from 'react';
import { request } from '../../../services/utilities';

export const confirmIVFStatusUpdate = (action, payload, alertText, alertHead) => {
	const [item] = payload;

	confirmAlert({
		customUI: ({ onClose }) => {
			// Create a React component so hooks can be used properly
			const IVFStatusModal = () => {
				const [selectedStatus, setSelectedStatus] = React.useState(null);
				const [notes, setNotes] = React.useState('');
				const [freezeNoteType, setFreezeNoteType] = React.useState('');
				const [isSubmitting, setIsSubmitting] = React.useState(false);

				const statusOptions = [
					{ value: 'success', label: 'Success', color: '#2ecc71', bgColor: '#e8f8f5', icon: '✓', endpoint: '/ivf/markSuccess' },
					{ value: 'failed', label: 'Failed', color: '#e74c3c', bgColor: '#fdedec', icon: '✗', endpoint: '/ivf/markFailed' },
					{
						value: 'discontinue',
						label: 'discontinue',
						color: '#95a5a6',
						bgColor: '#f8f9fa',
						icon: '⏸',
						endpoint: '/ivf/discontinueIvf',
					},
					{
						value: 'freeze',
						label: 'freeze',
						color: '#3498db',
						bgColor: '#eaf4fd',
						icon: '❄',
						endpoint: '/ivf/freezeIvf',
					},
				];

				const freezeNoteOptions = [
					{ value: 'pgt-a', label: 'PGT-A' },
					{ value: 'pgt-m', label: 'PGT-M' },
					{ value: 'embryo freezing', label: 'Embryo Freezing' },
					{ value: 'oocyte freezing', label: 'Oocyte Freezing' },
				];

				const getStatusStyle = status => {
					const option = statusOptions.find(opt => opt.value === status);
					return option || statusOptions[0];
				};

				const handleStatusChange = status => {
					setSelectedStatus(status);
					setFreezeNoteType('');
				};

				const handleSubmit = async () => {
					if (!selectedStatus) {
						notifyError('Please select a status');
						return;
					}

					if (selectedStatus === 'freeze' && !freezeNoteType) {
						notifyError('Please select a freeze note type');
						return;
					}

					setIsSubmitting(true);

					try {
						// Call the provided action with updated values
						await action(item.id, selectedStatus, selectedStatus === 'freeze' ? freezeNoteType : notes);
						notifySuccess(`IVF status updated to ${selectedStatus.toUpperCase()} successfully`);
						onClose();
					} catch (error) {
						notifyError(error.message || 'Failed to update IVF status');
					} finally {
						setIsSubmitting(false);
					}
				};

				const selectedStatusStyle = selectedStatus ? getStatusStyle(selectedStatus) : null;

				// Format date for display
				const formatDate = dateString => {
					if (!dateString) return 'N/A';
					const date = new Date(dateString);
					return date.toLocaleDateString();
				};

				return (
					<div className="onboarding-modal modal fade animated show" role="dialog" style={{ display: 'block' }}>
						<div className="modal-dialog modal-centered modal-md">
							<div className="modal-content text-center">
								<ModalHeader title={alertHead || 'Update IVF Status'} closeModal={onClose} />
								<div className="onboarding-content with-gradient">
									<div className="form-block">
										<Form
											onSubmit={handleSubmit}
											initialValues={{
												status: null,
												notes: '',
											}}
											render={({ handleSubmit }) => (
												<form onSubmit={handleSubmit}>
													{/* Current IVF Info */}
													<div
														className="mb-4 p-3"
														style={{
															backgroundColor: '#f8f9fa',
															borderRadius: '8px',
															border: '1px solid #dee2e6',
															textAlign: 'left',
														}}
													>
														<div style={{ fontSize: '13px', fontWeight: '600', color: '#2c3e50', marginBottom: '10px' }}>
															IVF Cycle Information
														</div>
														<div style={{ fontSize: '12px', marginBottom: '5px' }}>
															<strong>Serial Code:</strong> {item?.serial_code || 'N/A'}
														</div>
														<div style={{ fontSize: '12px', marginBottom: '5px' }}>
															<strong>Patient:</strong> {item?.wife?.surname || 'N/A'} {item?.wife?.other_names || ''}
														</div>
														<div style={{ fontSize: '12px', marginBottom: '5px' }}>
															<strong>Date of Commencement:</strong> {formatDate(item?.dateOfCommencement)}
														</div>
														<div style={{ fontSize: '12px', marginBottom: '5px' }}>
															<strong>Prognosis:</strong> {item?.prognosis || 'N/A'}
														</div>
														<div style={{ fontSize: '12px', marginBottom: '5px' }}>
															<strong>Treatment Plan:</strong> {item?.treatmentPlan || 'N/A'}
														</div>
														{item?.date_closed && (
															<div style={{ fontSize: '12px', marginBottom: '5px' }}>
																<strong>Date Closed:</strong> {formatDate(item?.date_closed)}
															</div>
														)}
													</div>

													{/* Status Selection */}
													<div className="mb-4">
														<label
															style={{ fontSize: '14px', fontWeight: '500', textAlign: 'center', marginBottom: '10px', display: 'block' }}
														>
															Please select a status to update the IVF cycle
														</label>
														<div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
															{statusOptions.map(option => (
																<button
																	key={option.value}
																	type="button"
																	onClick={() => handleStatusChange(option.value)}
																	style={{
																		flex: '1',
																		minWidth: '120px',
																		padding: '12px',
																		borderRadius: '8px',
																		border: selectedStatus === option.value ? `2px solid ${option.color}` : '1px solid #ddd',
																		backgroundColor: selectedStatus === option.value ? option.bgColor : 'white',
																		cursor: 'pointer',
																		transition: 'all 0.2s',
																		display: 'flex',
																		flexDirection: 'column',
																		alignItems: 'center',
																		gap: '5px',
																	}}
																	onMouseEnter={e => {
																		if (selectedStatus !== option.value) {
																			e.currentTarget.style.backgroundColor = '#f8f9fa';
																			e.currentTarget.style.transform = 'translateY(-2px)';
																		}
																	}}
																	onMouseLeave={e => {
																		if (selectedStatus !== option.value) {
																			e.currentTarget.style.backgroundColor = 'white';
																			e.currentTarget.style.transform = 'translateY(0)';
																		}
																	}}
																>
																	<span style={{ fontSize: '24px' }}>{option.icon}</span>
																	<span
																		style={{
																			fontSize: '14px',
																			fontWeight: selectedStatus === option.value ? 'bold' : 'normal',
																			color: selectedStatus === option.value ? option.color : '#666',
																		}}
																	>
																		{option.label}
																	</span>
																</button>
															))}
														</div>
													</div>

													{/* Freeze Note Type */}
													{selectedStatus === 'freeze' && (
														<div className="mb-4" style={{ textAlign: 'left' }}>
															<label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px', display: 'block' }}>
																Freeze Note Type
															</label>
															<select className="form-control" value={freezeNoteType} onChange={e => setFreezeNoteType(e.target.value)}>
																<option value="">Select freeze note type</option>
																{freezeNoteOptions.map(opt => (
																	<option key={opt.value} value={opt.value}>
																		{opt.label}
																	</option>
																))}
															</select>
														</div>
													)}

													{/* Preview of New Status */}
													{selectedStatus && (
														<div
															className="mb-4 p-3"
															style={{
																backgroundColor: selectedStatusStyle.bgColor,
																borderRadius: '8px',
																border: `1px solid ${selectedStatusStyle.color}`,
																textAlign: 'center',
															}}
														>
															<div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>The IVF status will be updated to</div>
															<div
																style={{
																	fontSize: '16px',
																	fontWeight: 'bold',
																	color: selectedStatusStyle.color,
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	gap: '8px',
																}}
															>
																<span>{selectedStatusStyle.icon}</span>
																<span>{selectedStatusStyle.label}</span>
															</div>
														</div>
													)}

													{/* Action Buttons */}
													<div className="form-buttons-w text-right" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
														<button className="btn btn-secondary" type="button" onClick={onClose} disabled={isSubmitting}>
															Cancel
														</button>
														<button
															className="btn btn-primary"
															type="submit"
															disabled={isSubmitting || !selectedStatus || (selectedStatus === 'freeze' && !freezeNoteType)}
															style={{
																backgroundColor: selectedStatusStyle?.color || '#3498db',
																borderColor: selectedStatusStyle?.color || '#3498db',
															}}
														>
															{isSubmitting ? (
																<>
																	<span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
																	Updating...
																</>
															) : selectedStatus ? (
																`Mark as ${selectedStatusStyle?.label}`
															) : (
																'Select Status'
															)}
														</button>
													</div>
												</form>
											)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				);
			};

			return <IVFStatusModal />;
		},
	});
};

// Helper function to get status badge
export const getIVFStatusBadge = status => {
	// Convert status from number/string to display value
	let displayStatus = '';
	if (status === '1' || status === 1) {
		displayStatus = 'open';
	} else if (status === '2' || status === 2) {
		displayStatus = 'success';
	} else if (status === '3' || status === 3) {
		displayStatus = 'failed';
	} else if (status === '4' || status === 4) {
		displayStatus = 'discontinue';
	} else {
		displayStatus = status;
	}

	const statusConfig = {
		open: {
			label: 'Open',
			color: '#3498db',
			bgColor: '#e8f4fd',
			icon: '🔄',
			className: 'badge-info',
		},
		success: {
			label: 'Success',
			color: '#2ecc71',
			bgColor: '#e8f8f5',
			icon: '✓',
			className: 'badge-success',
		},
		failed: {
			label: 'Failed',
			color: '#e74c3c',
			bgColor: '#fdedec',
			icon: '✗',
			className: 'badge-danger',
		},
		discontinue: {
			label: 'discontinue',
			color: '#95a5a6',
			bgColor: '#f8f9fa',
			icon: '⏸',
			className: 'badge-secondary',
		},
		freeze: {
			label: 'freeze',
			color: '#3498db',
			bgColor: '#eaf4fd',
			icon: '❄',
			className: 'badge-info',
		},
	};

	const config = statusConfig[displayStatus] || statusConfig.open;

	return (
		<span
			className={`badge ${config.className}`}
			style={{
				backgroundColor: config.bgColor,
				color: config.color,
				padding: '5px 10px',
				borderRadius: '20px',
				fontSize: '12px',
				fontWeight: '500',
				display: 'inline-flex',
				alignItems: 'center',
				gap: '5px',
			}}
		>
			<span>{config.icon}</span>
			<span>{config.label}</span>
		</span>
	);
};
